/*
 * @Name: manage/api
 * @Description: 页面管理相关api
 * @Author: xiadongxue
 * @Date: 2021-10-21 10:07:56
 * @Editors: xiadongxue
 */

import { jsonPost } from "@/assets/js/axios";
import axios from "axios";

//用户管理
let user = '/server/user'
//获取用户列表
const getUserList = (params) => jsonPost(`${user}/getUserList`,params)
//删除用户
const deleteUser = (params) => jsonPost(`${user}/updateUserStatus`,params)
//查询用户权限
const getUserPri = (params) => jsonPost(`${user}/getUserPri`,params)
//添加用户
const addUser = (params) => jsonPost(`${user}/addUser`,params)
//修改用户
const editUser = (params) => jsonPost(`${user}/editUser`,params)
//删除权限
const delUserPriByProject = (params) => jsonPost(`${user}/delUserPriByProject`,params)
//添加用户权限
const addUserPri = (params) => jsonPost(`${user}/addUserPri`,params)
//修改用户权限
const editUserPri = (params) => jsonPost(`${user}/editUserPri`,params)
//批量添加用户权限
const batchAddUserPri = (params) => jsonPost(`${user}/batch/addUserPri`,params)
//多邮箱列表
const emailList = (params) => axios.get('/server/system/config/email/suffix/listAll',{params})
//新增邮箱
const updateEmail = (params) => jsonPost('/server/system/config/email/suffix/addOrUpdate',params)

//查询菜单禁用列表
let menuGet = (params) => axios.get(`/server/role/app/menu/get`,{params})
//用户应用列表
let userApp = (params) => axios.get('/server/role/oauth/app/get',{params})
//用户大区列表
let userArea = (params) => axios.get('/server/area/oauth/get',{params})
//删除菜单禁用
let menuDelete = (params) => axios.post(`/server/role/app/menu/delete`,params)
//新增菜单禁用
let menuInsert = (params) => jsonPost('/server/role/app/menu/insert',params)
//编辑菜单禁用
let menuUpdate = (params) => jsonPost('/server/role/app/menu/update',params)
//菜单禁用复制
let menuCopy = (params) => jsonPost('/server/role/disable/copy',params)

//系统管理
let system = '/server/project'
//系统列表
const getProjectList = (params) => jsonPost(`${system}/getProjectList`,params)
//添加系统
const addProject = (params) => jsonPost(`${system}/addProject`,params)
//编辑系统
const editProject = (params) => jsonPost(`${system}/editProject`,params)
//删除系统
const delProject = (params) => jsonPost(`${system}/updateProjectStatus`,params)
//类别列表
const getCategoryList = () => axios.get(`${system}/category/list`)
//添加类别
const addCategory = (params) => jsonPost(`${system}/category/add`,params)
//编辑类别
const editCategory = (params) => jsonPost(`${system}/category/update`,params)
//删除类别
const delCategory = (params) => axios.post(`${system}/category/delete`,params)


//菜单管理
let menu = '/server/menu'
//获取菜单列表
const getMenuByProject = (params) => jsonPost(`${menu}/getMenuByProject`,params)
//添加菜单
const addMenu = (params) => jsonPost(`${menu}/addMenu`,params)
//修改菜单
const editMenu = (params) => jsonPost(`${menu}/editMenu`,params)
//修改菜单
const delMenu = (params) => jsonPost(`${menu}/delMenu`,params)


//角色管理
let role = '/server/role'
//角色列表
const getRolesByProjectId = (params) => jsonPost(`${role}/getRolesByProjectId`,params)
//删除角色
const delRole = (params) => jsonPost(`${role}/delRole`,params)
//添加角色
const addRole = (params) => jsonPost(`${role}/addRole`,params)
//修改角色
const editRole = (params) => jsonPost(`${role}/editRole`,params)
//根据角色id查询权限
const getMenuIdByRoleIds = (params) => jsonPost(`${role}/getMenuIdByRoleIds`,params)
//工种列表
const getWorkType = () => axios.get('/server/open/api/user/workType/list')
//角色详情
const getRoleById = (params) => jsonPost(`${role}/getRoleById4Edit`,params)

export {
    getUserList,
    deleteUser,
    getUserPri,
    addUser,
    editUser,
    delUserPriByProject,
    getProjectList,
    addProject,
    delProject,
    editProject,
    getMenuByProject,
    addMenu,
    editMenu,
    delMenu,
    getRolesByProjectId,
    delRole,
    addRole,
    editRole,
    getRoleById,
    addUserPri,
    editUserPri,
    getMenuIdByRoleIds,
    menuGet,
    userApp,
    userArea,
    menuDelete,
    menuInsert,
    menuCopy,
    menuUpdate,
    getCategoryList,
    delCategory,
    editCategory,
    addCategory,
    emailList,
    updateEmail,
    getWorkType,
    batchAddUserPri
}